import type { FieldError, UseFormRegisterReturn } from "react-hook-form";
import { Input } from "@components/ui/input";
import { Label } from "@components/ui/label";

type FormFieldProps = {
  id: string;
  label: string;
  registration: UseFormRegisterReturn;
  error?: FieldError;
  type?: string;
  autoComplete?: string;
  placeholder?: string;
  disabled?: boolean;
};

export function FormField({ id, label, registration, error, type, autoComplete, placeholder, disabled }: FormFieldProps) {
  return (
    <div className="space-y-2">
      <Label htmlFor={id}>{label}</Label>
      <Input
        id={id}
        {...registration}
        type={type}
        autoComplete={autoComplete}
        placeholder={placeholder}
        disabled={disabled}
        aria-invalid={Boolean(error)}
        aria-describedby={error ? `${id}-error` : undefined}
      />
      {error ? (
        <p id={`${id}-error`} role="alert" className="text-xs text-destructive">
          {error.message}
        </p>
      ) : null}
    </div>
  );
}
